<template>
  <div class="view" v-if="canView" v-cloak>
    <GridPanelHeader
      :title="$t('tools.measure_units.title')"
      :grid-ref="$refs[gridRefKey]"
      :show-add="false"
      :show-filter="false"
    />
    <DxDataGrid
      key-expr="id"
      :ref="gridRefKey"
      :data-source="measureUnitsDataSource"
      :remote-operations="gridRemoteOperations"
      :column-min-width="80"
      style="min-height: 350px"
      :show-column-lines="true"
      :show-row-lines="false"
      :show-borders="true"
      :column-auto-width="false"
      :allowColumnReordering="true"
      :allowColumnResizing="true"
      :row-alternation-enabled="true"
      :element-attr="gridAttributes"
    >
      <DxColumn
        dataField="name"
        :caption="$t('tools.measure_units.name')"
        :allowHeaderFiltering="false"
        :filter-operations="['contains']"
        :allowSorting="true"
      />
      <DxColumn
        dataField="code"
        :caption="$t('tools.measure_units.code')"
        :allowHeaderFiltering="false"
        :filter-operations="['contains']"
        :allowSorting="true"
        :width="120"
      />
      <DxColumn
        dataField="symbol"
        :caption="$t('tools.measure_units.symbol')"
        :allowHeaderFiltering="false"
        :filter-operations="['contains']"
        :allowSorting="true"
        :width="100"
      />
      <DxColumn
        dataField="description"
        :caption="$t('tools.measure_units.description')"
        :allowHeaderFiltering="false"
        :filter-operations="['contains']"
        :allowSorting="false"
      />
      <DxEditing :allowUpdating="false" :allowAdding="false" :allowDeleting="false" />
      <DxPaging :page-size="25" />
      <DxPager
        :visible="true"
        :allowed-page-sizes="pageSizes"
        display-mode="compact"
        :show-page-size-selector="true"
        :show-info="true"
        :show-navigation-buttons="true"
        :info-text="$t('common.page_info')"
      />
      <DxHeaderFilter :visible="true" />
      <DxFilterRow :visible="true" :showOperationChooser="true" apply-filter="auto" />
      <DxSelection mode="single" />
      <DxSearchPanel :visible="false" />
      <DxGroupPanel :visible="false" />
      <DxExport :enabled="false" />
      <DxColumnChooser :enabled="false" />
      <DxColumnFixing :enabled="true" />
    </DxDataGrid>
  </div>
  <div v-else>
    <forbidden></forbidden>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import DxDataGrid, {
  DxColumn,
  DxPaging,
  DxPager,
  DxEditing,
  DxHeaderFilter,
  DxFilterRow,
  DxSelection,
  DxSearchPanel,
  DxExport,
  DxGroupPanel,
  DxColumnChooser,
  DxColumnFixing,
} from "devextreme-vue/data-grid";
import Forbidden from "~/pages/errors/Forbidden.vue";
import CustomStore from "devextreme/data/custom_store";
import { canView, permissions, permissionTypes } from "~/helpers/Permissions";
import GridPanelHeader from "@/components/DxGrid/GridPanelHeader.vue";

export default {
  name: "MeasureUnits",
  components: {
    DxDataGrid,
    DxColumn,
    DxEditing,
    DxHeaderFilter,
    DxFilterRow,
    DxSelection,
    DxPaging,
    DxPager,
    DxSearchPanel,
    DxExport,
    DxGroupPanel,
    DxColumnChooser,
    DxColumnFixing,
    Forbidden,
    GridPanelHeader,
  },
  data() {
    return {
      gridAttributes: {
        class: "smagria-grid measure-units-grid",
      },
      gridRefKey: "measureUnitsGrid",
      measureUnitsDataSource: new CustomStore({
        key: "id",
        load: async (loadOptions) => {
          let dataSource = { data: [], totalCount: 0 };
          let payload = {
            limit: 9999,
            filter: loadOptions.filter,
            sort: loadOptions.sort,
          };
          try {
            await this.getMeasureUnitsFull(payload).then((response) => {
              dataSource.data = response.data.data;
              dataSource.totalCount = dataSource.data.length;
            });
            return dataSource;
          } catch (error) {
            console.error("Error fetching measure units:", error);
            throw error;
          }
        },
      }),
      gridRemoteOperations: {
        paging: false,
        filtering: false,
        sorting: false,
      },
      pageSizes: [15, 25, 100],
    };
  },
  computed: {
    config() {
      return {
        permission: permissions.SETTINGS,
        permission_type: permissionTypes.access,
      };
    },
    canView() {
      return canView(this);
    },
  },
  methods: {
    ...mapActions({
      getMeasureUnitsFull: "measureUnits/getMeasureUnitsFull",
    }),
  },
};
</script>
